(function ( $ ) {
	function setDomainName() {
		const url = window.location.href;
		const matches = url.match( /^https?:\/\/([^\/?#]+)(?:[\/?#]|$)/i );
		const hostName = matches && matches[1];
		const splitNames = hostName.split( /[\s.]+/ );

		// Replace subsidiary name so that the correct bvapi.js is loaded
		const replaceMap = {
			'colibrirealestate': 'realestateexpress',
			'elitelearning': 'elitecme'
		};

		for ( let i = 0; i < splitNames.length; i++ ) {
			const name = splitNames[i];
			if ( name in replaceMap ) {
				splitNames.splice( i, 1, replaceMap[name] );
				break;
			}
		}

		return splitNames[splitNames.length - 2];
	}


	function checkEnv() {
		let bvUrl = '';

		if ( bvMatchedEnv ) {
			// console.log('Bazaarvoice: Production API');
			return bvUrl;
		}

		bvUrl = 'bvstaging/';
		// console.log('Bazaarvoice: Staging API');
		return bvUrl;
	}

	const myUrl = window.location.href;
	const bvStageApi = [ 'www.', 'bvprod=true' ]; // Determine whether it is a live or staging environment for bvapi.js
	const bvMatchedEnv = RegExp( bvStageApi.join( '|' ) ).exec( myUrl );
	const bvApi = checkEnv();
	const bvSubsidiary = setDomainName(); // Retrieve the site domain name for bvapi.js

	// Initialise the Bazaarvoice front-end
	$.getScript(
		`//display.ugc.bazaarvoice.com/${ bvApi }static/${ bvSubsidiary }/en_US/bvapi.js?ver=4.7.2`,
		function () {
			if ( typeof $BV !== 'undefined' ) {
				(function ( $BV ) {
					const pageProductId = document.getElementById( 'pageProductId' );
					const productId = pageProductId?.dataset?.id;

					if ( productId ) {
						$BV.ui( 'qa', 'show_questions', {
							productId,
							subjectType: 'product'
						} );

						$BV.ui( 'rr', 'show_reviews', {
							productId
						} );
					}
				})( $BV );
			}
		}
	);
})( jQuery );
